<template>
  <div class="vc-content">
    <nav class="-nav">
      <nav-back-btn />
    </nav>

    <div class="-slogan row">
      <img
        src="../assets/logo.png"
        height="76"
        width="76"
        alt="Logo"
        class="-logo"
      />
      <span>货者网</span>
    </div>
    <div class="-input _mobile row">
      <input
        type="tel"
        placeholder="请输入手机号"
        maxlength="11"
        v-model="mobile"
      />
      <i v-if="mobile !== null && !isMobile" class="--tip">手机号码无效</i>
      <button v-if="!!mobile" @click="mobile = null" class="--clear">×</button>
    </div>
    <div class="-input _captcha row">
      <input
        type="tel"
        placeholder="填入 6 位验证码"
        maxlength="6"
        v-model="captcha"
      />
      <i v-if="captcha !== null && !isCaptcha" class="--tip">验证码无效</i>
      <button
        v-if="!isCaptchaRetry"
        @click="sendCaptcha"
        :disabled="isCaptchaSending"
      >
        发送验证码
        <b v-if="isCaptchaSending">&nbsp;{{ countdown }}s</b>
      </button>
      <button v-if="isCaptchaRetry" @click="sendCaptcha">重新发送</button>
    </div>
    <div class="row">
      <button @click="login" class="-login">确定</button>
    </div>
    <div v-if="false" class="row">
      <button @click="handleRegister" class="-register">立即注册</button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

import NavBackBtn from "@/components/NavBackBtn.vue";
import {isXCS} from "@/functions";

export default {
  name: "Login",
  data() {
    return {
      mobile: null,
      captcha: null,
      captchaId: null,
      interval: null,
      countdown: null,
    };
  },
  props: {
    cdTime: {
      type: Number,
      default: () => 60,
    },
  },
  computed: {
    isMobile() {
      return /^1[3-9]\d{9}$/.test(this.mobile);
    },
    isCaptcha() {
      return /\d{6}/.test(this.captcha);
    },
    isCaptchaRetry() {
      return this.countdown === 0;
    },
    isCaptchaSending() {
      return this.countdown !== null;
    },
  },
  methods: {
    async sendCaptcha() {
      if (this.mobile === null) this.mobile = "";
      if (!this.isMobile) return;

      const { mobile } = this;

      this.countdown = this.cdTime;

      this.$store.dispatch("sendCaptcha", { mobile }).then(({ id }) => {
        this.captchaId = id;
      });

      if (this.interval !== null) clearInterval(this.interval);

      this.interval = window.setInterval(() => {
        if (this.countdown <= 0) return clearInterval(this.interval);

        this.countdown--;
      }, 1000);
    },
    async login() {
      if (this.mobile === null) this.mobile = "";
      if (this.captcha === null) this.captcha = "";

      if (!this.isMobile || !this.isCaptcha) return;

      const { mobile, captcha, captchaId } = this;

      try {
        await this.$store.dispatch("webLogin", {
          mobile,
          captcha,
          captchaId,
        });

        this.$nextTick(() => this.$router.replace("home"));
      } catch (error) {
        Toast(error);
      }
    }
  },
  mounted()
  {
    console.log("mounted call...");
    const ua = navigator.userAgent;
    if(isXCS())
    {
      console.log("mounted call 2...");
      try {
        this.$store.dispatch("xcsLogin", {
          ua
        }).then(info => {
          console.log("mounted .then..."+info);
          this.$nextTick(() => this.$router.replace("home"));

        });


      } catch (error) {
        console.log("mounted .error..."+error);
        Toast(error);
      }
    }

  },
  components: {
    NavBackBtn,
  },
};
</script>

<style lang="less" scoped>
.vc-content {
  @color: #181949;

  width: 80vw;
  color: @color;
  font-size: 16px;
  margin: auto;
  padding: 48px 16px;
  flex-direction: column;
  align-items: center;
  display: flex;

  .-logo {
    border-radius: 100%;
  }

  .-slogan {
    font-weight: bold;
    margin-top: 56px;
    margin-bottom: 96px;
    flex-direction: column;
    align-items: center;
    display: flex;
  }

  input {
    border: none;
  }

  button {
    user-select: none;
    border: none;
    padding: 0;
    background: none;
    outline: none;

    &:active {
      opacity: 0.9;
    }

    &[disabled] {
      opacity: 0.5;
      background: none !important;
      color: @color;
    }
  }

  .row {
    width: 100%;
    display: flex;
  }

  .-nav {
    width: 100%;
    padding: 8px;
    top: 0;
    left: 0;
    position: absolute;
  }

  .-input {
    height: 24px;
    width: 100%;
    border-bottom: 1px solid @color;
    padding: 12px 0;
    margin-bottom: 12px;
    position: relative;

    > input {
      height: 100%;
      width: 100%;
    }
    .--tip {
      color: rgb(243, 63, 63);
      font-size: 12px;
      text-decoration: none;
      bottom: -22px;
      left: 0;
      position: absolute;
    }
    &._mobile {
      .--clear {
        border-radius: 24px;
        height: 24px;
        width: 24px;
        color: #000000;
        font-size: 24px;
        font-family: sans-serif;
        justify-content: center;
        align-items: center;
        display: flex;
        margin: auto;
        line-height: 24px;
        bottom: 0;
        top: 0;
        right: 0;
        position: absolute;
      }
    }

    &._captcha {
      > button {
        margin: auto;
        bottom: 0;
        top: 0;
        right: 0;
        position: absolute;
      }
    }
  }

  .-login {
    border-radius: 4px;
    background: @color;
    width: 100%;
    height: 48px;
    color: white;
    font-size: 18px;
    margin-top: 12px;
  }

  .-register {
    height: 24px;
    line-height: 24px;
    padding: 12px 0;
    margin-left: auto;
    box-sizing: content-box;
  }
}
</style>
